// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    AutocompleteBrandsStyles,
    autocompleteBrandsStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteBrands";
import { autoCompleteSharedStyles } from "@sc/App/WidgetExtensions/Header/SearchInputExtensions";
import { color, mergeWithCss } from "@sc/XDL/Utilities";
import { css } from "styled-components";

const autoCompleteBrandsExtensions: AutocompleteBrandsStyles = {
    headerText: {
        ...autoCompleteSharedStyles?.headerText,
    },
    link: {
        ...mergeWithCss(autoCompleteSharedStyles?.link, {
            css: css`
                display: flex;
                margin-bottom: 13px;
            `,
        }),
    },
    focusedBrandItemText: {
        ...mergeWithCss(autoCompleteSharedStyles?.focusedItemText, {
            css: css`
                display: flex;
                flex-direction: column;
                background: ${color("common.ui3")};
            `,
        }),
    },
    focusedLink: {
        ...mergeWithCss(autoCompleteSharedStyles.focusedLink, {
            typographyProps: {
                weight: "bold",
            },
        }),
    },
    brandItemText: {
        ...mergeWithCss(autoCompleteSharedStyles?.itemText, {
            css: css`
                display: flex;
                flex-wrap: wrap;
                gap: 4px;
                && {
                    margin-bottom: 0;
                }
            `,
        }),
    },
};

autocompleteBrandsStyles.headerText = autoCompleteBrandsExtensions.headerText;
autocompleteBrandsStyles.link = autoCompleteBrandsExtensions.link;
autocompleteBrandsStyles.focusedBrandItemText = autoCompleteBrandsExtensions.focusedBrandItemText;
autocompleteBrandsStyles.focusedLink = autoCompleteBrandsExtensions.focusedLink;
autocompleteBrandsStyles.brandItemText = autoCompleteBrandsExtensions.brandItemText;
